import { __assign } from '../../external/tslib/tslib.es6.mjs.js';
import { jsxs, jsx, Fragment } from 'react/jsx-runtime';
import clsx from 'clsx';
import dayjs from 'dayjs';
import { RecursiveIcon } from '../../icons/RecursiveIcon.js';
import { constants } from '../../constants/index.js';
import styles from './BillDue.module.scss.js';

var getDateText = function (datePrefixText, date) {
    return date ? "".concat(datePrefixText, " ").concat(dayjs(date).format(constants.DATE_SHORT_MONTH_FORMAT)) : '';
};
var BillDue = function (_a) {
    var _b;
    var variant = _a.variant, hasError = _a.hasError, date = _a.date, className = _a.className, style = _a.style;
    return (jsxs("p", __assign({ style: style, className: clsx(styles.billDue, (_b = {}, _b[styles.billDueRecursive] = variant === 'recursive', _b[styles.billDueError] = hasError, _b), className) }, { children: [variant === 'endorsement' && jsx(Fragment, { children: "One time payment due today" }), variant === 'single' && !hasError && jsxs(Fragment, { children: ["Due ", getDateText('on', date)] }), variant === 'single' && hasError && jsxs(Fragment, { children: ["Past due", getDateText(':', date)] }), variant === 'recursive' && (jsxs(Fragment, { children: [jsxs("span", { children: [!hasError && jsx(RecursiveIcon, {}), "Auto Pay ", hasError && " failed "] }), getDateText('on', date)] }))] })));
};

export { BillDue };
